import React from 'react';
import { BasicVettingProcessColumnProps } from '..';

export const MainRoleField: React.FC<BasicVettingProcessColumnProps> = ({
  vettingProcess,
}) => <>{vettingProcess.user.roleCategory?.title}</>;
